import type { GetAllPartiesByDistributionV2Response } from 'wg-api-sdk';

type PartyFields = GetAllPartiesByDistributionV2Response['items'][number];

export type DemoPartyOverride = {
  brokerEmail: string;
  partyEmail: string;
  overrides: Partial<
    Pick<
      PartyFields,
      | 'name'
      | 'first_name'
      | 'infix'
      | 'last_name'
      | 'email'
      | 'telephonenr'
      | 'address'
      | 'external_refs'
      | 'type'
    >
  >;
};

export const DEMO_PARTY_OVERRIDES: DemoPartyOverride[] = [
  {
    brokerEmail: '@wegroup.',
    partyEmail: 'j.olderechterschot@planet.nl',
    overrides: {
      name: 'Aggrarier Ago',
      type: 'COMPANY',
      email: 'arjuna@wegroup.nl',
      telephonenr: '+31 6 479 372 96',
      address: {
        street: 'Kerkstraat',
        housenr: '',
        country_code: 'NL',
        zipcode: '5242KR',
        city: "'s-Hertogenbosch",
      },
    },
  },
];
